import React from 'react';
import { Card, Form } from 'react-bootstrap';

// Card with a bold title and an optional action in the header, separated from the content by a line.
// `header` replaces the whole header content when the header needs more than a title and an action.
const SectionCard = _ref => {
  let {
    title,
    action,
    header,
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    className: className
  }, /*#__PURE__*/React.createElement(Card.Header, null, header ?? /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "fw-bold mb-0"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "text-nowrap ms-3"
  }, action))), /*#__PURE__*/React.createElement(Card.Body, null, children));
};
export default SectionCard;